import * as t from './types';
import { searchService } from 'modules/Search/services/SearchMiniSiteService';

export const searchFetch = (query: string) => async (dispatch: any, getState: any) => {
    dispatch({ type: t.FETCH_SEARCH_START });

    try {
        if (query.length > 0) {
            const response = await searchService.searchFetch(query);
            dispatch({ type: t.FETCH_SEARCH_SUCCESS, payload: { data: response, query } });
        } else {
            dispatch({ type: t.FETCH_SEARCH_SUCCESS, payload: { data: undefined, query } });
        }
    } catch (error) {
        dispatch({ type: t.FETCH_SEARCH_FAILURE, payload: error.response });
    }
};

export const searchClear = () => async (dispatch: any) => {
    dispatch({ type: t.CLEAR_SEARCH_SUCCESS });
};
